import { useOnlineStatus } from "./useOnlineStatus.js";

export interface OfflineBannerProps {
  readonly onRetry?: () => void;
  readonly testId?: string;
}

export function OfflineBanner(props: OfflineBannerProps) {
  const online = useOnlineStatus();
  if (online) {
    return null;
  }
  return (
    <output
      aria-live="polite"
      data-testid={props.testId ?? "offline-banner"}
      className="pwz-sheet pwz-mark flex flex-wrap items-center justify-between gap-3 py-3 pr-3 pl-4"
    >
      <div className="min-w-0">
        <p className="pwz-eyebrow text-warn-500">Нет сети</p>
        <p className="mt-1 min-w-0 break-words text-sm text-ink-900">
          Изменения недоступны, пока соединение не восстановится.
        </p>
      </div>
      {props.onRetry ? (
        <button
          type="button"
          className="pwz-btn pwz-btn-secondary shrink-0"
          data-testid="offline-retry"
          onClick={props.onRetry}
        >
          Повторить
        </button>
      ) : null}
    </output>
  );
}
